import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e755c218"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "settings-form__content" }
const _hoisted_2 = { class: "settings-form__wrapper" }
const _hoisted_3 = { class: "settings-form__footer" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Сохранить данные ")

import { defineComponent, reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, FormInstance, FormRules } from 'element-plus'
import { NewPasswordType } from '@/shared/types'
import { settingsApi } from '@/shared/api'
import { showErrorMessage, validateMatchPasswords } from '@/shared/utils'
import { useUser } from '@/shared/composables'
import { COMMON_RULES } from '@/shared/constants'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { user } = useUser()

const router = useRouter()

const settingsForm = ref<FormInstance>()

const settingsFormData: NewPasswordType = reactive({
  email: user.value.email,
  password: '',
  passwordConfirmation: '',
})

const settingsValidationRules = reactive<FormRules>({
  email: [COMMON_RULES.emailRequired, COMMON_RULES.emailIncorrect],
  password: [
    COMMON_RULES.passwordRequired,
    COMMON_RULES.passwordTooShort,
    COMMON_RULES.passwordTooLong,
    COMMON_RULES.passwordHasNotLetter,
    COMMON_RULES.passwordHasSpace,
    COMMON_RULES.passwordTooEasy,
  ],
  passwordConfirmation: [
    COMMON_RULES.repeatPassword,
    COMMON_RULES.passwordTooShort,
    COMMON_RULES.passwordTooLong,
    COMMON_RULES.passwordHasNotLetter,
    COMMON_RULES.passwordHasSpace,
    COMMON_RULES.passwordTooEasy,
    {
      validator: (_, value, callback) =>
        validateMatchPasswords(settingsFormData.password, value, callback),
      trigger: 'blur',
    },
  ],
})

const handleSubmitForm = (): void => {
  if (!settingsForm.value) return

  settingsForm.value.validate(async (valid): Promise<boolean> => {
    if (valid) {
      const [error] = await settingsApi.updateProfile(settingsFormData)

      if (error) {
        showErrorMessage(error)

        return false
      }

      ElMessage({
        message: 'Данные обновлены',
        type: 'success',
      })

      router.back()
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    ref_key: "settingsForm",
    ref: settingsForm,
    model: _unref(settingsFormData),
    rules: _unref(settingsValidationRules),
    class: "settings-form"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    class: "settings-form__item",
                    prop: "email"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _unref(settingsFormData).email,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(settingsFormData).email) = $event)),
                        disabled: "",
                        placeholder: "Email"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    class: "settings-form__item",
                    prop: "password"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _unref(settingsFormData).password,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(settingsFormData).password) = $event)),
                        placeholder: "Пароль",
                        "show-password": "",
                        type: "password"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    class: "settings-form__item",
                    prop: "passwordConfirmation"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _unref(settingsFormData).passwordConfirmation,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(settingsFormData).passwordConfirmation) = $event)),
                        placeholder: "Повтор пароля",
                        "show-password": "",
                        type: "password"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          class: "settings-form__button",
          round: "",
          type: "primary",
          onClick: handleSubmitForm
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}
}

})